module.exports = __webpack_public_path__ + "img/05.cfe73a58.png";